export enum ConstraintTypeEnum {
    HalfBounded = 0,
    Bounded = 1,
    Relative = 2,
    Readonly = 3,
    SuperAdminOnly = 4,
    Rename = 5
}
